import React, { useEffect, useState } from 'react'
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, TablePagination, Button
} from '@mui/material';
import Error from '../../utils/Error';
import Success from '../../utils/Success';
import { apiCall, downloadApiCall } from '../../../service';
import config from '../../config';
import Navbar from '../navbar/Navbar';
import "./punctuality.css"

const WeekDetailedReport = () => {
    const [loading, setLoading] = useState(true);
    const [detailedReportData, setDetailedReportData] = useState([]);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [dataSuccessMessage, setDataSuccessMessage] = useState(false);
    const [dataErrorMessage, setDataErrorMessage] = useState(false);

    const [searchQuery, setSearchQuery] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const [downloadLoading, setDownloadLoading] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        const data = JSON.parse(localStorage.getItem("rowDataWeek"));

        const fetchData = async (data) => {
            try {
                // const payload = {
                //     host: config.apiEndpoints.punctualityReport.host,
                //     endPoint: endpoint,
                //     method: "GET",
                // };
                const payload = {
                    host: config.apiEndpoints.moreDetailWeekReport.host,
                    endPoint: config.apiEndpoints.moreDetailWeekReport.url,
                    method: "POST",
                    body: {
                        serviceId: data.serviceID,
                        to: data.to,
                        from: data.from,
                    },
                };
                const response = await apiCall(payload)
                setLoading(false)
                if (response.status) {
                    const responseData = await response;
                    setDataSuccessMessage(true);
                    setSuccessMessage(response.message);
                    // console.log("data ", responseData.data.data)

                    const allReportData = responseData.data.data.map((data) => {
                        // const punctualityStatus = data.status.toLowerCase() === "late" ? "Late" : "On-Time";
                        // const onTimePercentage = data.status.toLowerCase() === "late" ? "0%" : "100%";

                        return {
                            hop: data.hop,
                            scheduledDeparture: data.schedule_dept ? formatDate(data.schedule_dept) : formatDate(data.schedule_dept),
                            averageDelay: data.avgDelay ? data.avgDelay : data.avgDelay,
                            earlyCount: data.earlyCount ? data.earlyCount : data.earlyCount,
                            lateCount: data.lateCount ? data.lateCount : data.lateCount,
                            earlyMin: data.earlyMin ? data.earlyMin : data.earlyMin,
                            lateMin: data.lateMin ? data.lateMin : data.lateMin,
                            scheduledArrival: data.schedule_arrival ? formatDate(data.schedule_arrival) : formatDate(data.schedule_arrival),
                            // actualDeparture: data.act_dept ? formatDate(data.act_dept) : "N/A",
                            // actualArrival: data.act_arrival ? formatDate(data.act_arrival) : "N/A",
                            // punctualityStatus: punctualityStatus,
                            // onTimePercentage: onTimePercentage,
                        };
                    });
                    setDetailedReportData(allReportData);
                    setLoading(false);
                    setTimeout(() => {
                        setSuccessMessage('');
                        setDataSuccessMessage(false);
                    }, 1000);
                }
            } catch (error) {
                setDataErrorMessage(true);
                setErrorMessage(error.message || "Something went wrong.");

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
                setLoading(false);
            }
        };

        if (data) {
            fetchData(data);
        } else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        setPage(0);
    }, [searchQuery]);

    const filteredVehicles = detailedReportData.filter((report) =>
        report.hop.toLowerCase().includes(searchQuery)
    );

    const displayedVehicles = searchQuery ? filteredVehicles : detailedReportData;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (isoDateString) => {
        let dateIST = new Date(isoDateString);
        return dateIST.toLocaleString('en-IN', {
            timeZone: 'Asia/Kolkata',
            hour: 'numeric',
            minute: 'numeric',
            // year: 'numeric',
            // month: '2-digit',
            // day: '2-digit',
            hour12: true,
        });
    };


    const handleDownloadReports = async () => {
        try {
            const data = JSON.parse(localStorage.getItem("rowDataWeek"));
            console.log("data" , data);
            const payload = {
                host: config.apiEndpoints.punctualityReportWeekDownload.host,
                endPoint: config.apiEndpoints.punctualityReportWeekDownload.url,
                method: "POST",
                body: {
                    serviceId: data.serviceID,
                    to: data.to,
                    from: data.from,
                },
            };
            const response = await downloadApiCall(payload)
            console.log("response" , response);
            if (response.status === 400) {
                const errorData = await response.json();
                const errorMessage = errorData.message || "Something went wrong";
                setDataErrorMessage(true);
                console.log("responned error: ", await response)
                setErrorMessage(errorMessage);
                setDownloadLoading(false);

                setTimeout(() => {
                    setErrorMessage('');
                    setDataErrorMessage(false);
                }, 1000);
                return;
            } else {
                const blob = await response.blob();
                const filename = `Punctuality Week Report.csv`
                const link = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setDataSuccessMessage(true);
                setSuccessMessage("Successfully downloaded");
                setDownloadLoading(false);

                setTimeout(() => {
                    setSuccessMessage('');
                    setDataSuccessMessage(false);
                }, 1000);
            }
        } catch (error) {
            console.log("error", error);
            setDataErrorMessage(true);
            setErrorMessage(error.data || "Something went wrong.");
            setDownloadLoading(false);

            setTimeout(() => {
                setErrorMessage('');
                setDataErrorMessage(false);
            }, 1000);
        }
    }
    return (
        <>
            <Navbar
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                placeholder="Search Hop..."
            />
            {
                loading ?
                    <div className="loader-wrapper">
                        <div className="truck-wrapper">
                            <div className="truck">
                                <div className="truck-container"></div>
                                <div className="glases"></div>
                                <div className="bonet"></div>
                                <div className="base"></div>
                                <div className="base-aux"></div>
                                <div className="wheel-back"></div>
                                <div className="wheel-front"></div>
                                <div className="smoke"></div>
                            </div>
                        </div>
                    </div>
                    :
                    <>
                        <div className='header-div'>
                            <h1 style={{ fontSize: "26px", fontWeight: "bold", margin: "0px 10px 10px 10px" }}>Week Detailed Report</h1>
                            {
                                detailedReportData.length > 0 && (
                                    <Button
                                        variant="outlined"
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "grey",
                                            color: "white",
                                            marginRight: "5px"
                                        }}
                                        disabled={downloadLoading}
                                        onClick={() => handleDownloadReports()}
                                        className='btnReport'>{downloadLoading ? "Downloading Report" : "Download Report"}
                                    </Button>
                                )
                            }
                        </div>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            "& th": {
                                                fontWeight: "bold",
                                                fontSize: "17px"
                                            }
                                        }}
                                    >
                                        <TableCell>S.No.</TableCell>
                                        <TableCell>Hop</TableCell>
                                        <TableCell>Scheduled Arrival</TableCell>
                                        <TableCell>Scheduled Depature</TableCell>
                                        {/* <TableCell>Actual Departure</TableCell> */}
                                        <TableCell>Early Arrival Hops</TableCell>
                                        <TableCell>Early Arrival in Mins</TableCell>
                                        <TableCell>Late Arrival Hops</TableCell>
                                        <TableCell>Late Arrival in Mins</TableCell>
                                        <TableCell>Average Delay/Early</TableCell>
                                        {/* <TableCell>Punctuality Status</TableCell>
                                        <TableCell>Actual Arrival</TableCell>
                                        <TableCell>On-Time(%)</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {displayedVehicles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                                            <TableCell>{data.hop}</TableCell>
                                            <TableCell>{data.scheduledArrival}</TableCell>
                                            <TableCell>{data.scheduledDeparture}</TableCell>
                                            <TableCell>{data.earlyCount}</TableCell>
                                            <TableCell>{Math.round(data.earlyMin)} mins</TableCell>
                                            <TableCell>{data.lateCount}</TableCell>
                                            <TableCell>{Math.round(data.lateMin)} mins</TableCell>
                                            <TableCell>{Math.round(data.averageDelay)} mins</TableCell>
                                            {/* <TableCell>{data.actualArrival}</TableCell> */}
                                            {/* <TableCell>{data.actualDeparture}</TableCell> */}
                                            {/* <TableCell>{data.punctualityStatus}</TableCell> */}
                                            {/* <TableCell>{data.onTimePercentage}</TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                component="div"
                                count={displayedVehicles.length}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                rowsPerPageOptions={[20, 30, 40, 50]}
                                labelRowsPerPage="Rows per page"
                            />
                        </TableContainer>
                        <>
                            {
                                dataSuccessMessage ? (
                                    <div style={{ position: "fixed", bottom: "5%", right: "0%", width: "100%", zIndex: "969895" }}>
                                        <Success msg={successMessage} />
                                    </div>
                                ) : null
                            }
                            {
                                dataErrorMessage ? (
                                    <div style={{ position: "fixed", bottom: "5%", right: "0%", width: "100%", zIndex: "969895" }}>
                                        <Error msg={errorMessage} />
                                    </div>
                                ) : null
                            }
                        </>
                    </>
            }
        </ >
    )
}

export default WeekDetailedReport